export default __webpack_public_path__ + "static/media/hirkolaleLake.b2618e5b.jpg";